import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { LemonSlice } from './botanical/LemonSlice';
export function NewTomos() {
  const tomos = [{
    title: 'Tos, Garganta y Fiebre',
    desc: 'Qué hacer exactamente cuando aparecen los primeros síntomas respiratorios.'
  }, {
    title: 'Acidez, Gases y Digestión',
    desc: 'Soluciones rápidas para la panza hinchada y el malestar estomacal.'
  }, {
    title: 'Estrés, Ansiedad e Insomnio',
    desc: 'Cómo calmar la mente y lograr un descanso profundo sin medicación.'
  }, {
    title: 'Dolores y Molestias Cotidianas',
    desc: 'Alivio natural para dolores de cabeza, espalda y tensión muscular.'
  }, {
    title: 'Defensas y Recuperación',
    desc: 'Qué hacer para fortalecer el cuerpo y recuperarse más rápido.'
  }];
  return <Section className="bg-cream relative overflow-hidden py-20" data-id="element-324">
      <LemonSlice className="absolute top-1/4 -right-20 w-96 h-96 text-honey opacity-5 blur-sm pointer-events-none hidden md:block" aria-hidden="true" data-id="element-325" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-326">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-327">
          Lo que vas a encontrar adentro
        </h2>

        <div className="space-y-4" data-id="element-328">
          {tomos.map((tomo, idx) => <Card key={idx} className="p-5 md:p-6 bg-white shadow-md border-sage-mist/50 flex items-center gap-4" data-id="element-329">
              <span className="text-2xl shrink-0" data-id="element-330">🌿</span>
              <div data-id="element-331">
                <h3 className="text-lg md:text-xl font-bold text-forest-deep" data-id="element-332">
                  {tomo.title}
                </h3>
                <p className="text-forest/80" data-id="element-333">{tomo.desc}</p>
              </div>
            </Card>)}
        </div>
      </div>
    </Section>;
}